<template>
  <v-container grid-list-xs fluid>
    <v-layout wrap>
      <v-flex xs6 >
        <v-select v-model="numberOfRiders" :items="['1', '2', '3', '4+']" hint="# Ryders" persistent-hint>
        </v-select>
      </v-flex>
      <v-flex xs6>
        <v-select v-model="rydeTypeToggle" :items="['uber', 'lyft', 'taxi']" hint="Ryde Type?" multiple small-chips deletable-chips persistent-hint>
          <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index === 0">
              <span>{{item}}</span>
            </v-chip>
            <span
              v-if="index === 1"
              class="gray--text caption"
            >
              (+{{ rydeTypeToggle.length - 1 }} others)
            </span>
          </template>
        </v-select>
      </v-flex>
    </v-layout>

    <v-layout row wrap class="rydes">
      <v-flex>
        <v-list two-line subheader>
          <v-subheader>Rydes</v-subheader>
          <div v-if="loading" class="text-center">
            <BaseLoading></BaseLoading>
          </div>
          <template v-else v-if="rydes.length > 0" v-for="ryde in filteredRydes" >
            <v-list-tile @click="" :key="ryde.rideID">
              <v-list-tile-avatar>
                <v-avatar v-if="ryde.rideID.indexOf('ryde') != -1 ">
                  <img :src="getLyftIcon(ryde.rideID)" alt="alt">
                </v-avatar>
                <v-icon v-else
                  :color=" ryde.type == 'lyft' ? 'pink lighten-2' : ryde.type == 'taxi' ? 'yellow accent-3' : 'black' ">
                  {{ ryde.type == 'taxi' ? 'local_taxi' : 'directions_car' }}
                </v-icon>
              </v-list-tile-avatar>
              
              <v-list-tile-content>
                <v-list-tile-title v-text="'$'+ryde.priceFloor+(ryde.priceCeiling == ryde.priceFloor ? '' : '-$' + ryde.priceCeiling) "></v-list-tile-title>
                <v-list-tile-sub-title v-text="ryde.displayName"></v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-list-tile-action-text>{{ryde.rideDuration}} min ryde</v-list-tile-action-text>
                <v-btn icon ripple :href="getAppLink(ryde)">
                  <v-icon color="primary">navigation</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider inset></v-divider>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import axios from 'axios'

  export default {
    name: 'RydesList',
    props: {
      origin: {
        type: Object,
        required: true
      }, 
      destination: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        loading: true,
        lyftRideTypes: [
          {
            ride_type: "lyft_line",
            display_name: "Lyft Line",
            image_url: "https://cdn.lyft.com/assets/car_standard.png",
            seats: 2
          },
          {
            ride_type: "lyft",
            display_name: "Lyft",
            image_url: "https://cdn.lyft.com/assets/car_standard.png",
            seats: 4
          },
          {
            ride_type: "lyft_plus",
            display_name: "Lyft Plus",
            image_url: "https://cdn.lyft.com/assets/car_plus.png",
            seats: 6
          },
          {
            ride_type: "lyft_premier",
            display_name: "Lyft Premier",
            image_url: "https://cdn.lyft.com/assets/car_plus.png",
            seats: 4
          },
          {
            ride_type: "lyft_lux",
            display_name: "Lyft Lux",
            image_url: "https://cdn.lyft.com/assets/car_plus.png",
            seats: 4
          },
          {
            ride_type: "lyft_luxsuv",
            display_name: "Lyft Lux SUV",
            image_url: "https://cdn.lyft.com/assets/car_plus.png",
            seats: 6
          }],
        rydes: [],
        rydeTypeToggle: [ 'lyft', 'uber', 'taxi' ], 
        showTypeToggle: false,
        showNumberOfRiders: false,
        numberOfRiders: 1
      }
    },
    computed: {
      filteredRydes: function(){
        return this.rydes.filter((item) => {
          return this.rydeTypeToggle.includes(item.type)
        })
      }, 
      lyftRideNames: function(){
        let returnRideNames = []

        this.lyftRideTypes.forEach((item) => {
          returnRideNames.push(item.display_name)
        });

        return returnRideNames;
      }
    },
    mounted: function(){
      // console.log(this.origin); 
      // console.log(this.destination);

      if(this.origin && this.destination){
        this.getZoomRydeInformation(this.origin, this.destination, (response)=> {
          this.loading = false
          response.data.forEach((item) => {
            let type = (item.rideID.indexOf('lyft') != -1) ? 'lyft' : (item.displayName.indexOf('Taxi') != -1) ? 'taxi' : 'uber';

            var updatedItem = Object.assign({type: type}, item);

            this.rydes.push(updatedItem)
          })
        });
      }
    },
    methods: {
      // lyft(type){
      //   return this.lyftRideTypes[type]
      // },
      getZoomRydeInformation(origin, destination, callback){
        const originLocation = (typeof origin.geometry.location.lat == 'function') ? {
          lat: origin.geometry.location.lat(), 
          lng: origin.geometry.location.lng() 
        } : {
          lat: origin.geometry.location.lat, 
          lng: origin.geometry.location.lng
        }

        const destinationLocation = (typeof destination.geometry.location.lat == 'function') ? {
          lat: destination.geometry.location.lat(), 
          lng: destination.geometry.location.lng()
        } : {lat: destination.geometry.location.lat, lng: destination.geometry.location.lng }

        axios.get('https://zoomryde.com/getrides.php?action=getpricesestimates', {
          params: {
            currentLat: originLocation.lat, 
            currentLong: originLocation.lng,
            finalLat: destinationLocation.lat,
            finalLong: destinationLocation.lng,
          }
        })
        .then((response) => {
          this.loading = false;
          callback(response);
        })
        .catch((err) => {
          console.log(err);
        })
      }, 
      // getBirdToken(){
        // const GUIDs = [
        //   '047DCA17-7932-4ED0-A290-B4C00AC9215D',
        //   '01265EFD-54B7-4BE3-9D99-250C0F7C3F17',
        //   '48DBDE14-B725-46BC-9E29-53727A7640F1',
        //   '3192C6A9-1FF4-49DC-906D-015FB039C62F', 
        //   '52166B05-8CDB-4C9E-9F43-E114C95B6CE7'];

        // const email = 'jsheppard11@apu.edu';

        // let birdData = { data: {
        //   latitude: 34.0271534, 
        //   longitude: -117.5983318
        // }}

        // axios.post('http://localhost:5000/zoomryde/us-central1/getBirdData', 
        // birdData,
        // {
        //   headers: {
        //     'Content-Type': 'application/json'
        //   }
        // }) 
        // .then((response) => {
        //   console.log(response);
        // })
        // .catch((err) => {
        //   console.log(error);
        // })
      // },
      getLyftIcon(rydeId){
        let result = this.lyftRideTypes.filter(function(element){
          return element.ride_type == rydeId
        })
        return result[0] ? result[0].image_url : '';
      },
      getAppLink(ryde, origin = this.origin, destination = this.destination){
        if(origin && destination){
          if(ryde.displayName.indexOf('Taxi') != -1){
            return 'tel://'+ryde.phoneNumber;

          } else if (ryde.displayName.indexOf('Lyft') != -1){

            return 'https://lyft.com/ride?id='+ryde.rideID+'&pickup[latitude]='+this.origin.geometry.location.lat+'&pickup[longitude]='+this.origin.geometry.location.lng+'&partner=vDHSSfHzKlze&destination[latitude]='+this.destination.geometry.location.lat+'&destination[longitude]='+this.destination.geometry.location.lng;

          } else if (ryde.displayName.indexOf('Uber') != -1){
            
            return 'https://m.uber.com/ul/?client_id=Dezdtol77lCZ8Tg8MeHTslkALS_BN3yB&action=setPickup&pickup[latitude]='+this.origin.geometry.location.lat+'&pickup[longitude]='+this.origin.geometry.location.lng+'&pickup[nickname]=Me&pickup[formatted_address]='+this.origin.address+'&dropoff[latitude]='+this.destination.geometry.location.lat+'&dropoff[longitude]='+this.destination.geometry.location.lng+'&dropoff[nickname]=Destination&dropoff[formatted_address]='+this.destination.address+'&product_id='+ryde.rideID+'&link_text=View%20team%20roster&partner_deeplink=partner%3A%2F%2Fteam%2F9383';
          }
        } else {

        }
      }
    }
  }
</script>
<style>
  
</style>